import React from "react";
import { createRoot } from "react-dom/client";
import "@auction-eth/ui-kit/tokens.css";
import "@auction-eth/ui-kit/governance-login.css";
import "./globals.css";
import { App } from "./App.js";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");
createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
